import type { ScheduledDowngradeBannerPageStore } from '@ctct/state-client-layer';
import type { CancelScheduledDowngradeMutation } from '@ctct/state-server-layer';

import type { TranslationGetter, TranslationPaths } from '../../../types';

export class ScheduledDowngradeService {
  constructor(
    private hasScheduledDowngrade: boolean,
    private cancelScheduledDowngradeMutation: CancelScheduledDowngradeMutation,
    private pageStore: ScheduledDowngradeBannerPageStore,
    private t: TranslationGetter,
    private isCoreMutationLockedAccount: boolean
  ) {}

  public api() {
    return {};
  }

  public data() {
    return {
      shouldDisplayBanner: () => this.hasScheduledDowngrade,
      isCoreMutationLockedAccount: () => this.isCoreMutationLockedAccount,
      getBannerContent: () => {
        return {
          title: this.t('application-layer.scheduled-downgrade-banner.title'),
          textKey: 'application-layer.scheduled-downgrade-banner.text' as TranslationPaths,
        };
      },
    };
  }

  public handlers() {
    return {
      onCancelScheduledDowngrade: async () => {
        if (this.isCoreMutationLockedAccount) {
          return;
        }

        this.disable();

        try {
          await this.cancelScheduledDowngradeMutation.mutateAsync();
        } finally {
          this.enable();
        }
      },
    };
  }

  private disable() {
    this.pageStore.setState({ scheduledDowngradeBannerDisabled: true });
  }

  private enable() {
    this.pageStore.setState({ scheduledDowngradeBannerDisabled: false });
  }
}
